import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Excluir", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Concluir", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_11 = { class: "ant-col ant-col-xs-7 ant-col-xl-7" }
const _hoisted_12 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_13 = { class: "ant-col ant-col-xs-7 ant-col-xl-7" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-5 ant-col-xl-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Identificador")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-7 ant-col-xl-7" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Título")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-5 ant-col-xl-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Tipo de Elemento")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ativo")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col",
    style: {"margin-left":"5px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_recurso = _resolveComponent("selecionar-recurso")!
  const _component_selecionar_tipo_elemento = _resolveComponent("selecionar-tipo-elemento")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_apresentar_grupo_campos = _resolveComponent("apresentar-grupo-campos")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_grupo_campos_modal = _resolveComponent("grupo-campos-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        keyboard: false,
        visible: _ctx.modalBase.computedVisivel,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
        style: {"width":"750px"}
      }, {
        title: _withCtx(() => [
          _createTextVNode("Personalização de Tela")
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            (_ctx.state.exibirBotaoExcluir)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-danger",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                }, _hoisted_2))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
            }, _hoisted_4)
          ])
        ]),
        closeIcon: _withCtx(() => [
          _createVNode(_component_icone, { nome: "voltar" })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_skeleton, {
            active: "",
            loading: _ctx.telaBase.carregando,
            paragraph: { rows: 2 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_form_item, {
                        label: "Empresa",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_empresa, {
                            disabled: _ctx.props.recurso !== undefined,
                            codigoSelecionado: _ctx.state.personalizacao.codigoEmpresa,
                            "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.personalizacao.codigoEmpresa) = $event))
                          }, null, 8, ["disabled", "codigoSelecionado"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_form_item, {
                        label: "Tela",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_recurso, {
                            disabled: _ctx.props.recurso !== undefined,
                            recursoSelecionado: _ctx.computedTela,
                            "onUpdate:recursoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedTela) = $event))
                          }, null, 8, ["disabled", "recursoSelecionado"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_card, { titulo: "Grupos de Campos" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Identificador",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                ref: "campoNovoGrupo",
                                type: "text",
                                maxlength: "100",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.novoGrupo.identificador) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.novoGrupo.identificador]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_form_item, {
                            label: "Título",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "100",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.novoGrupo.titulo) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.novoGrupo.titulo]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo de Elemento",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_elemento, {
                                tipoElemento: _ctx.state.novoGrupo.tipoElemento,
                                "onUpdate:tipoElemento": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.novoGrupo.tipoElemento) = $event))
                              }, null, 8, ["tipoElemento"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "ant-btn ant-btn-primary ant-btn-block",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.adicionarGrupo()))
                              }, "Adicionar")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _hoisted_14,
                      (_ctx.state.personalizacao.gruposCamposPersonalizados.length <= 0)
                        ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                            key: 0,
                            mensagem: "Nenhum grupo adicionado ainda"
                          }))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.state.personalizacao.gruposCamposPersonalizados, (grupo, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "ant-row ss-grade-personalizada-linha",
                              key: index
                            }, [
                              _createVNode(_component_apresentar_grupo_campos, {
                                grupo: _ctx.state.personalizacao.gruposCamposPersonalizados[index],
                                "onUpdate:grupo": ($event: any) => ((_ctx.state.personalizacao.gruposCamposPersonalizados[index]) = $event),
                                onEditarGrupo: ($event: any) => (_ctx.editarGrupo(grupo)),
                                onRemoverGrupo: ($event: any) => (_ctx.removerGrupo(index,grupo.identificador))
                              }, null, 8, ["grupo", "onUpdate:grupo", "onEditarGrupo", "onRemoverGrupo"])
                            ]))
                          }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    (_ctx.state.montarModalGrupo)
      ? (_openBlock(), _createBlock(_component_grupo_campos_modal, {
          key: 0,
          visivel: _ctx.state.exibirModalGrupos,
          "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.exibirModalGrupos) = $event)),
          grupo: _ctx.state.grupoEditado,
          "onUpdate:grupo": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.grupoEditado) = $event))
        }, null, 8, ["visivel", "grupo"]))
      : _createCommentVNode("", true),
    _createVNode(_component_requisicao_modal, {
      visivel: _ctx.modalBase.exibirRequisicaoModal,
      "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
      apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
      retornoRequisicao: _ctx.modalBase.retornoRequisicao
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
  ], 64))
}